import useAppStore from '$appStore'
import { CountryLocaleOptions, LocaleOptions } from '$constants'
import { CompanyPreferences } from '$utils'
import { NumberParser } from '../../numberParser'

/**
 * Formats a given number to a given precision (decimal places)
 * @param numberValue the number to be formatted
 * @param precision the decimal places to format the number too (defaults to 0)
 * @returns formatted number
 */
export function formatNumber(
  numberValue: string | number | null | undefined,
  precision: number = 0
): string {
  const companyCountry: string = useAppStore
    .getState()
    .activeCompany?.preference(CompanyPreferences.Locale) as string

  const config: LocaleOptions =
    CountryLocaleOptions[companyCountry] || CountryLocaleOptions['default']

  const LocaleAwareParser = new NumberParser(config.locale)

  const numberFormat: Intl.NumberFormat = Intl.NumberFormat(config.locale, {
    style: 'decimal',
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  })
  let value: string = ''

  // Only a missing value is blank. A zero is a real number and has to be
  // formatted like any other, otherwise the caller shows nothing where the
  // answer genuinely is zero.
  if (numberValue == null || numberValue === '') {
    value = ''
  } else {
    const safeValue =
      typeof numberValue === 'string'
        ? LocaleAwareParser.parse(numberValue)
        : numberValue
    value = numberFormat.format(safeValue)
  }
  return value
}

export function formatNumberToDecimalPlaces(
  numberValue: number | undefined,
  multiplier: number = 100
): number {
  return (
    Math.round(((numberValue ?? 0) + Number.EPSILON) * multiplier) / multiplier
  )
}
